import { useCallback, useContext, useId, useMemo } from 'react';

import { NavigationConfirmationManagerContext } from '../useNavigationConfirmationManager';
import useNavigationConfirmationTrigger from '../useNavigationConfirmationTrigger';
import NavigationConfirmationEnvironmentContext from './context';

const useNavigationConfirmationEnvironment = () => {
  const environmentId = useId();
  const parentEnvironment = useContext(NavigationConfirmationEnvironmentContext);
  const manager = useContext(NavigationConfirmationManagerContext);

  const { tryNavigatingAway, isNavigatingAway } = useNavigationConfirmationTrigger(environmentId);

  const subscribeToForm: (formId: string) => void = useCallback(
    (formId: string) => {
      manager.subscribeToForm(formId, environmentId);
      parentEnvironment?.subscribeToForm(formId);
    },
    [environmentId, manager, parentEnvironment],
  );

  return useMemo(
    () => ({
      subscribeToForm,
      environmentId,
      tryNavigatingAway,
      isNavigatingAway,
    }),
    [environmentId, isNavigatingAway, subscribeToForm, tryNavigatingAway],
  );
};

export default useNavigationConfirmationEnvironment;
